import store from '../../../../store';
export default function checkIfCanUpdate() {
  let exists = false;
  let scopes = store.getters.userScopes;
  if (scopes.includes('system_company_update_all') || scopes.includes('system_company_update_company')) {
    exists = true;
  }
  return exists;
}
